import { render, staticRenderFns } from "./UpdateBusinessMemberPhoneNumber.vue?vue&type=template&id=544a7f29&"
import script from "./UpdateBusinessMemberPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./UpdateBusinessMemberPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports